import ConsentDialog from "@/features/consent/ConsentDialog";
import useConsentDialog from "@/features/consent/hooks/useConsentDialog";
import { useDiaryByIdQuery } from "@/features/diaries/api";
import { useSelectDiaryLabels, type DiaryLabelOption } from "@/features/diaries/api/selectDiaryLabels";
import { DiaryLabelCallList } from "@/features/diaries/components/DiaryLabelCallList";
import FormsToDo from "@/features/diaries/features/new/FormsToDo";
import { createFileRoute } from "@tanstack/react-router";

const HomeToDoPage = () => {
    const { diaryId } = Route.useParams();
    const { data: diary } = useDiaryByIdQuery(diaryId);
    const { data: allLabels = [] } = useSelectDiaryLabels();
    const consentState = useConsentDialog({ diaryId, embeddedConsents: diary?.consents_view });

    if (!diary) {
        return null;
    }

    const labelNames = diary.diary_labels ?? [];
    const matchedLabels = labelNames
        .map((name) => allLabels.find((l) => l.label_name === name))
        .filter((l): l is DiaryLabelOption => l != null);

    const diaryComplete = diary.tab.toLowerCase() === "inactive";
    const hasBlockingConsent = consentState.showDialog && !!consentState.nextUnsignedConsent?.consent_id;

    return (
        <>
            <DiaryLabelCallList labels={matchedLabels} />
            <FormsToDo
                diary={diary}
                diaryComplete={diaryComplete}
                trackers={diary.trackers_view}
                blockingTask={hasBlockingConsent ? <ConsentDialog diaryId={diaryId} state={consentState} /> : undefined}
                blockingTaskCount={consentState.unsignedConsents.length}
            />
        </>
    );
};

export const Route = createFileRoute("/_app/diaries/$diaryId/home/to-do")({
    component: HomeToDoPage,
});
